var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgThermostat(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 128,
    height: 127,
    viewBox: "0 0 128 127",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2516",
    "data-name": "Rectangle 2516",
    width: 51.089,
    height: 87.526,
    fill: "#b99354"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6828",
    "data-name": "Group 6828",
    transform: "translate(0.197 -0.467)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2515",
    "data-name": "Rectangle 2515",
    width: 128,
    height: 127,
    transform: "translate(-0.197 0.467)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6827",
    "data-name": "Group 6827",
    transform: "translate(43.258 20.204)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6826",
    "data-name": "Group 6826",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4693",
    "data-name": "Path 4693",
    d: "M18.519,87.526c-.514-.121-1.035-.232-1.54-.339a31.962,31.962,0,0,1-3.36-.843A20.3,20.3,0,0,1,7.291,51.609a2.157,2.157,0,0,0,.773-1.822c-.009-13.743-.014-25.2,0-37.092A11.933,11.933,0,0,1,14.616,1.47,11.953,11.953,0,0,1,20.359,0a12.445,12.445,0,0,1,8.388,3.327,11.964,11.964,0,0,1,3.823,8.505c.1,3.842.079,7.756.058,11.541-.009,1.637-.018,3.329-.018,4.995v1.64c0,6.478,0,13.177-.012,19.764a2.293,2.293,0,0,0,.831,1.861c6.611,5.97,8.748,13.13,6.353,21.28C37.436,80.9,31.869,85.746,23.236,87.328c-.249.046-.5.094-.746.142l-.289.056ZM20.368,3.962a8.033,8.033,0,0,0-3.426.764C13.662,6.258,12,9.005,12.007,12.89q.012,8.377.007,16.755c0,7.093,0,14.427.016,21.64a2.976,2.976,0,0,1-1.362,2.707,16.391,16.391,0,0,0-5.4,19.614,16.6,16.6,0,0,0,15.085,9.975h0a15.972,15.972,0,0,0,2.721-.234A16.144,16.144,0,0,0,36.3,70.778c1.421-6.823-.708-12.483-6.327-16.82A3.017,3.017,0,0,1,28.641,51.3c.024-4.818.02-9.716.017-14.453q0-2.569,0-5.137v-.622h-.023q0-2.682.018-5.364c.021-4.546.042-9.247-.05-13.873a8.189,8.189,0,0,0-8.232-7.89",
    transform: "translate(0)",
    fill: "#b99354"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4694",
    "data-name": "Path 4694",
    d: "M192.04,53.7c-.487,0-.974,0-1.461-.011a2.026,2.026,0,0,1-2.208-1.943,1.838,1.838,0,0,1,.516-1.349,2.35,2.35,0,0,1,1.692-.652c1.249-.01,2.52-.015,3.779-.015s2.557.005,3.835.016a1.987,1.987,0,1,1-.019,3.948h-3.837q-.576,0-1.152,0t-1.146,0",
    transform: "translate(-149.307 -39.414)",
    fill: "#b99354"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4695",
    "data-name": "Path 4695",
    d: "M192,103.839c-.566,0-1.031,0-1.465-.012a1.979,1.979,0,1,1,.007-3.941c1.3-.013,2.6-.021,3.866-.021s2.572.007,3.831.021a1.982,1.982,0,1,1-.025,3.945h-3.938q-.57,0-1.141,0t-1.136,0",
    transform: "translate(-149.305 -79.155)",
    fill: "#b99354"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4696",
    "data-name": "Path 4696",
    d: "M192,153.986c-.486,0-.972,0-1.457-.011a1.979,1.979,0,1,1-.01-3.94c1.271-.015,2.563-.023,3.841-.023s2.572.008,3.854.023a1.984,1.984,0,1,1-.08,3.942q-.723.009-1.446.008l-1.2,0-1.158,0h-.033q-.579,0-1.158,0t-1.153,0",
    transform: "translate(-149.304 -118.903)",
    fill: "#b99354"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4697",
    "data-name": "Path 4697",
    d: "M192.01,204.133c-.5,0-.995,0-1.493-.011a1.974,1.974,0,1,1-.047-3.936c1.268-.02,2.577-.029,3.892-.029,1.264,0,2.572.009,3.887.027a1.978,1.978,0,1,1-.04,3.939q-.726.01-1.453.009l-1.186,0-1.164,0c-.41,0-.808,0-1.206,0s-.793,0-1.19,0",
    transform: "translate(-149.306 -158.649)",
    fill: "#b99354"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4698",
    "data-name": "Path 4698",
    d: "M60.142,156.145a9.981,9.981,0,0,1-9.753-7.7,9.578,9.578,0,0,1,1.219-7.435,10.018,10.018,0,0,1,6.029-4.459l.452-.129v-5.872q0-14.137,0-28.274v-.112a4.192,4.192,0,0,1,.065-.947A2,2,0,0,1,60.045,99.7l.086,0a2.041,2.041,0,0,1,1.9,1.807,5.3,5.3,0,0,1,.017.641c0,.081,0,.162,0,.242v33.973l.444.133a10.3,10.3,0,0,1,6.189,4.788,9.91,9.91,0,0,1-8.266,14.857c-.09,0-.18,0-.27,0m-.083-15.93a6.012,6.012,0,0,0-5.98,6.013,5.991,5.991,0,0,0,5.981,5.959h0a5.986,5.986,0,0,0,.047-11.972Z",
    transform: "translate(-39.719 -79.023)",
    fill: "#b99354"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThermostat);
export default __webpack_public_path__ + "static/media/thermostat.b122914de5369f1efe704bffc73f96cb.svg";
export { ForwardRef as ReactComponent };